import { render, staticRenderFns } from "./monitoring-service-callback-client-modal.vue?vue&type=template&id=c2d979a4"
import script from "./monitoring-service-callback-client-modal.vue?vue&type=script&lang=js"
export * from "./monitoring-service-callback-client-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports